__turbopack_context__.v({
  "homeLink": "Logo-module-scss-module__dpzdQW__homeLink",
});
